import handleQueryError from '../../../util/Common/Error/Handler/handleQueryError';
import commonDefaultAPI from '../api';

const getChassisTypeList = async ({ keyword }) => {
  try {
    const response = await commonDefaultAPI.get(
      `chassis-type-list${keyword ? `/${keyword}` : ''}`,
    );
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getChassisTypeList;
